import { Installation } from 'src/Libs/installations/models/installation.model'
import { hasAccessToDirectMarketing } from '../has-access-to-direct-marketing'
import { UserData } from '@e3dc-react/shell/Types'

/**
 * Return true if the installation is located in germany and user is owner of the installation
 */
export const hasAccessToLuoxDirectMarketing = (installation?: Installation, userData?: UserData): boolean => {
  if (!hasAccessToDirectMarketing(installation, userData)) return false

  return true
}
